import { createRequestReducer } from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'

const AcceptTCReducer = combineReducers({
  acceptTcRequest: createRequestReducer('ACCEPT_TC:SEND')
})

export default AcceptTCReducer
